import React, { useEffect } from "react";
import { Page, PageHeader } from "../../../components/page";
import {
  deferralsStatusSelector,
  planInfoStatusSelector,
  sessionStatusSelector,
  useStatuses,
} from "../../../selectors/status";
import ContributionsSummaryInfo from "./contributions-summary-anchor-info";
import ContributionsSummaryWrapper from "./contributions-summary-wrapper";
import { fetchDeferrals } from "../../../reducers/deferrals/defferals";
import { useAppDispatch, useSelector } from "../../../store/store";

export default function ContributionsSummaryPage() {
  const { planId, empId } = useSelector((state) => state.session);
  const { isLoadingStatus } = useStatuses([
    sessionStatusSelector,
    planInfoStatusSelector,
    deferralsStatusSelector,
  ]);
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(fetchDeferrals({ planId, empId }));
  }, [planId, empId]);

  return (
    <Page
      printable
      className="investment-allocations"
      name="investment-allocations"
      loading={isLoadingStatus}
    >
      <PageHeader name="investment-allocations">Contributions</PageHeader>
      <ContributionsSummaryWrapper />
      <ContributionsSummaryInfo />
    </Page>
  );
}
